// extracted by mini-css-extract-plugin
module.exports = {"expanded-interpretation-wrapper":"ExpandedInterpretation_expanded-interpretation-wrapper__1GQn_"};